import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var dev=!(window.location.host=='wx.hooply.net')//true 为测试环境，false 为正式环境
const store = new Vuex.Store({
	state: {
		dev:dev,
		// baseurl: dev?'https://apitest.hooply.net/hooply_admin':'https://api.hooply.net:8090', 2022.7.5修改之前的
		// baseurl: dev?'https://apitest.hooply.net/hooply_admin':'https://api.hooply.net/hladmin/v1',
		//baseurl:'https://adminabroadapi.hooply1988.net',  //发布到国外的接口 
		baseurl:'https://api.hooply1988.net/hladmin/v1',//发布到国内的接口
		loginstate:false,//登录状态
		routername:'',//路由名
		language:'zh-CN',
//业务数据
	//大一统
	//预约租聘
		/*appointby:{
			name:'',//预约姓名
			phone:'',//联系电话
			install_address:'',//安装地址
			is_appoint:'',
			pageid:1,//当前页面数
			pagesize:10,//页面显示数据条数
		},//用户登录日志条件*/
	},
	getters: {
		test: state => {
			return 0;
		}
	},
	mutations: {
		//预约租聘搜索条件
		/*setAppoint(state, param) {
			state.appointby=param
		},*/
	},
	actions: {
	//大一统
		async post({state},param){
			//带cooike请求头
			
			axios.defaults.withCredentials = true

			param.d.language = window.localStorage.getItem('language') || state.language;
			
			let params = new URLSearchParams(param.d)
			let config = {
				headers:{'language':window.localStorage.getItem('language') || state.language}
				
			};
			return await axios.post(state.baseurl+param.u,params,config).then(function(res){
				return res.data
			})
		},
		//单文件上传
		async upfile({state,dispatch},param){
			//带cooike请求头
			axios.defaults.withCredentials = true
			let config = {
				headers:{'Content-Type':'multipart/form-data'}
			};
			let params = new FormData(); //创建form对象
			params.append('chunk','0');//添加form表单中其他数据
		//上传文件
			//验证上传文件为图片
			if(param.dev){
				param.dev.img=param.f//传参赋值
				return await dispatch('compress',param.dev).then(function(res){
					if(res.err==0){
						params.append('file',res.data,param.f.name);//通过append向form对象添加数据
						for(var k in param.d){
							params.append(k, param.d[k])
						}
						return axios.post(state.baseurl+param.u,params,config).then(function(res){
							return res.data
						})
					}else{
						return res
					}
				})
			}else{
				params.append('file',param.f,param.f.name);//通过append向form对象添加数据
				for(var k in param.d){
					params.append(k, param.d[k])
				}
				return axios.post(state.baseurl+param.u,params,config).then(function(res){
					return res.data
				})
			}
		},
		//多文件上传
		async upfiles({state},param){
			//带cooike请求头
			axios.defaults.withCredentials = true
			let config = {
				headers:{'Content-Type':'multipart/form-data'}
			};
			let params = new FormData(); //创建form对象
			//上传文件
			params.append('chunk','0');//添加form表单中其他数据
			for(var d in param.f){
				params.append(d,param.f[d],param.f[d].name);//通过append向form对象添加数据
			}
			for(var k in param.d){
				params.append(k, param.d[k])
			}
			return await axios.post(state.baseurl+param.u,params,config).then(function(res){
				return res.data
			})
		},
		compress({},obj){
			//obj->img图片文件,obj->dev误差(deviation)—— 0-1,obj->w宽,obj->h高(w或h其中之一不填会默认为正方形，以填写的数据为准)
			//obj->dev > 0 时为容差压缩，压缩后的长宽为确切数据，和原图比会变形，容差为长宽比上额外的百分比
			//obj->dev = 0 时为精准压缩，压缩后的长宽比不变，和原图比不会变形，长宽为压缩后图片的最大值，
			let res = new Promise(function(resolve, reject){//做一些异步操作
				// 压缩图片需要的一些元素和对象
				var reader = new FileReader(),file = new Image();
				reader.readAsDataURL(obj.img);
				// 缩放图片需要的canvas
				var canvas = document.createElement('canvas');
				var context = canvas.getContext('2d');
				// 文件base64化，以便获知图片原始尺寸
				reader.onload = function(e) {
					file.src = e.target.result;
				};
				// base64地址图片加载完毕后
				file.onload = function() {
					// 图片原始尺寸
					var originWidth = this.width;
					var originHeight = this.height;
					// 最大尺寸限制
					var maxWidth,maxHeight
					if(obj.w && obj.h){
						maxWidth = obj.w,maxHeight = obj.h;
					}else if(obj.w || obj.h){
						maxWidth = obj.w?obj.w:obj.h,maxHeight = maxWidth;
					}
					// 目标尺寸
					var targetWidth = originWidth,
						targetHeight = originHeight;
					// 图片尺寸超过限定尺寸的限制
					if(obj.dev>0){
						if((maxWidth / maxHeight)*0.9 < originWidth / originHeight && originWidth / originHeight < (maxWidth / maxHeight)*1.1) {
							targetHeight = maxHeight;
							targetWidth = maxWidth;
						} else {
							resolve({"err":4,"data":"图片上传失败,图片比例不正确,请上传长宽比为"+(maxHeight/maxWidth).toFixed(2)+"的图片"});
						}
					}else if(obj.dev===0 && (originWidth > maxWidth || originHeight > maxHeight)){
						if(originWidth / originHeight > maxWidth / maxHeight) {
							// 更宽，按照宽度限定尺寸
							targetWidth = maxWidth;
							targetHeight = Math.round(maxWidth * (originHeight / originWidth));
						} else {
							//更高
							targetHeight = maxHeight;
							targetWidth = Math.round(maxHeight * (originWidth / originHeight));
						}
					}
					// canvas对图片进行缩放
					canvas.width = targetWidth;
					canvas.height = targetHeight;
					// 清除画布
					context.clearRect(0, 0, targetWidth, targetHeight);
					// 图片压缩
					context.drawImage(file, 0, 0, targetWidth, targetHeight);
					// canvas转为blob并上传
					canvas.toBlob(function(blob) {
						resolve({"err":0,"data":blob});
					}, file.type || 'image/png');
				};
			});
			return res;
		},
		async get({state},param){
			//带cooike请求头
			axios.defaults.withCredentials = true
			return await axios.get(state.baseurl+param).then(function(res){
				return res.data
			})
		},
	//业务代码
		/*appoint({state,commit,dispatch},param){
			let router=param.router,notify=param.notify,self=param.self
			dispatch('post',{u:'/appoint_lease/list',d:state.appointby}).then(function(res){
		    	if(res.err==0){
		    		state.appointby.pageid=res.data.pageid
		    		commit('setAppoint',state.appointby)//防止数据到不存在页面后显示不正确
					self.tableData=res.data
					return
		    	}
		    	if(res.err==101){
		    		notify({
						title: '未登录，跳转到登录页面！',
						type: 'warning'
					});
					router.push('/');
					return
		    	}
			})
		},*/
	}
})
export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js